import { useEffect } from "react";
import { useProductData } from "@/zustand/productStore";
import { useCartData } from "@/zustand/cartStore";
import getDefaultVariantsState from "@/func/defaultVariants";

export const useInitializeDefaultProduct = (enabled = true) => {
  const productData = useProductData();
  const { shouldUseBundleTitle } = useProductData();
  const { setSelectedProduct, setVariants, setWarrantyState, selectedProduct } = useCartData();

  useEffect(() => {
    if (enabled && productData?.products && !selectedProduct) {
      const defaultProductIndex = productData.products.findIndex((item) => item.best_seller === true);

      const enableVariants = productData?.enable_color_variants || productData?.enable_size_variants;
      if (enableVariants) {
        const variantsState = getDefaultVariantsState(productData);
        setVariants(variantsState);
      }
      if (productData?.preselect_warranty && productData?.add_warranty_for_product) {
        setWarrantyState(true);
      }

      const productToSelect =
        defaultProductIndex > -1 ? productData.products[defaultProductIndex] : productData.products[0];

      const bundleTitle = shouldUseBundleTitle ? productToSelect.bundle_title : null;

      if (productToSelect) {
        setSelectedProduct({
          sku: productToSelect.sku?.trim(),
          amount: productToSelect.amount,
          konnektive_id: productToSelect.konnektive_id?.trim(),
          bundle_products: productToSelect.bundle_products,
          warranty_price: productToSelect.warranty_price,
          warranty_product_id: productToSelect.warranty_product_id,
          display_name: productToSelect.display_name,
          generic_name: productToSelect.generic_name,
          bundle_title: bundleTitle,
          price: productToSelect.price,
          old_price: productToSelect.old_price,
          shipping_price: productToSelect.shipping_price,
          promo_discounted_price: productToSelect.promo_discounted_price,
          promo_shipping_price: productToSelect.promo_shipping_price,
          fake_products: productToSelect.fake_products,
          enable_fake_products: productToSelect.enable_fake_products,
        });
      }
    }
  }, [enabled, productData, selectedProduct, setSelectedProduct, setVariants, setWarrantyState]);
};
